import { ListInfoComponent } from './list-info.component';

export default ListInfoComponent;
